export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
export const CLARITY_ID = import.meta.env.VITE_CLARITY_ID;

export function pageview(url) {
  try {
    if (!window.gtag) {
      return;
    }
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: url,
    });
  } catch (error) {
    console.warn("[Analytics] Error tracking pageview:", error);
  }
}

export function loadGoogleAnalytics() {
  if (window.gtag) return Promise.resolve(); // already loaded

  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

      script.onload = () => {
        try {
          // Init GA
          window.dataLayer = window.dataLayer || [];
          function gtag() { window.dataLayer.push(arguments); }
          window.gtag = gtag;
          gtag("js", new Date());
          gtag("config", GA_MEASUREMENT_ID);

          console.info("[Analytics] Google Analytics loaded successfully");
          resolve();
        } catch (error) {
          console.warn("[Analytics] Error initializing Google Analytics:", error);
          reject(error);
        }
      };

      script.onerror = (error) => {
        console.warn("[Analytics] Failed to load Google Analytics:", error);
        reject(error);
      };

      document.head.appendChild(script);
    } catch (error) {
      console.warn("[Analytics] Error creating Google Analytics script:", error);
      reject(error);
    }
  });
}

export function loadClarity() {
  if (window.clarity && typeof window.clarity === 'function') return Promise.resolve(); // already loaded

  return new Promise((resolve) => {
    try {
      // Initialize Clarity queue before loading script to prevent errors
      window.clarity = window.clarity || function() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

      const script = document.createElement("script");
      script.async = true;
      script.defer = true; // Add defer to ensure proper loading order
      script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
      
      // Add a timeout to prevent hanging
      const timeoutId = setTimeout(() => {
        console.warn("[Analytics] Clarity loading timeout, continuing without it");
        resolve();
      }, 5000);
      
      // Add error handling for script execution
      script.onload = () => {
        try {
          // Wait a bit for Clarity to initialize
          setTimeout(() => {
            clearTimeout(timeoutId);
            if (typeof window.clarity === 'function') {
              console.info("[Analytics] Microsoft Clarity loaded successfully");
              resolve();
            } else {
              console.warn("[Analytics] Clarity script loaded but function not available");
              resolve(); // Still resolve to not break the app
            }
          }, 200); // Increased timeout for Clarity initialization
        } catch (error) {
          clearTimeout(timeoutId);
          console.warn("[Analytics] Error initializing Microsoft Clarity:", error);
          resolve(); // Resolve instead of reject to not break analytics
        }
      };

      script.onerror = (error) => {
        clearTimeout(timeoutId);
        console.warn("[Analytics] Failed to load Microsoft Clarity:", error);
        resolve(); // Resolve instead of reject to not break analytics
      };

      // Add to head instead of trying to insert before first script
      document.head.appendChild(script);
    } catch (err) {
      console.error("[Analytics] Unexpected error while loading Clarity:", err);
      resolve(); // Resolve instead of reject to not break analytics
    }
  });
}
